import request from '@/utils/request'

/**
 * 根基账号获取店铺名称
 */
export function getDpList(){
    return request({
        url: '/store/getDpList',
        method: 'get'
    })
}

/**
 * 获取移动分类树数据
 */
export function getTreeList(params){
    return request({
        url: '/store/getTreeList',
        method: 'get',
        params: params
    })
}

/**
 * 根据form表单查询表格
 * @param form
 */
export function getInnerDataList(form){
    // 搜索类型为 1标题 2SKU 3产品ID
    var param ={};
    let time1;
    let time2;
    if(form.dateValue!=null &&form.dateValue!='undefined'&&form.dateValue.length>0){
         time1= form.dateValue[0];//开始时间
         time2= form.dateValue[1];//结束时间
    }
    if(form.searchType != 'undefined' && form.searchType!='' && form.searchType==1){
        param ={'shopId':form.name == 'all'?null:form.name,'proTitle':form.searchStr,'pubStatus':form.pubStatus,
            'pageNum':form.pageNum,'pageSize':form.pageSize,'typeNo':form.typeNo,'lSite':form.station,
            'dateType':form.dateType,time1:time1,time2:time2,inventory_start:form.inventory_start,inventory_end:form.inventory_end,
            price_start:form.price_start,price_end:form.price_end,pro_price_start:form.pro_price_start,pro_price_end:form.pro_price_end
        }
    }else if(form.searchType != 'undefined' && form.searchType!='' && form.searchType==2){
        param ={'shopId':form.name == 'all'?null:form.name,'skuNo':form.searchStr,'pubStatus':form.pubStatus,
            'pageNum':form.pageNum,'pageSize':form.pageSize,'typeNo':form.typeNo,'lSite':form.station,
            'dateType':form.dateType,'time1':time1,'time2':time2,'inventory_start':form.inventory_start,'inventory_end':form.inventory_end,
            'price_start':form.price_start,'price_end':form.price_end,'pro_price_start':form.pro_price_start,'pro_price_end':form.pro_price_end
        }
    }else if(form.searchType != 'undefined' && form.searchType!='' && form.searchType==3){
        param ={'shopId':form.name == 'all'?null:form.name,'lPId':form.searchStr,'pubStatus':form.pubStatus,
            'pageNum':form.pageNum,'pageSize':form.pageSize,'typeNo':form.typeNo,'lSite':form.station,
            'dateType':form.dateType,time1:time1,time2:time2,inventory_start:form.inventory_start,inventory_end:form.inventory_end,
            price_start:form.price_start,price_end:form.price_end,pro_price_start:form.pro_price_start,pro_price_end:form.pro_price_end
        }
    }
    return request({
        url: '/product/lazada/getInnerDataList',
        method: 'get',
        params: param
    })
}

/**
 * 将Lazada产品由采集箱移入到待发布
 * @param pId
 */
export function moveToReady(pId){
    return request({
        url: '/product/lazada/moveToReady',
        method: 'put',
        data: {'pId':pId,'pubStatus':'02'}
    })

}


/**
 * 将Lazada产品由采集箱移入到待发布
 * @param pId
 */
export function updateToShelves(pId){
    return request({
        url: '/product/lazada/moveToReady',
        method: 'put',
        data: {'pId':pId,'pubStatus':'06'}//下架商品
    })

}




/**
 * 将Lazada产品由采集箱批量移入到待发布
 * @param data
 */
export function bathMoveToReady(data){
    return request({
        url: '/product/lazada/bathMoveToReady',
        method: 'put',
        data: data
    })
}

//通过P_ID删除Lazada产品的相关联表数据
export function singledelete(params) {
    return request({
        url: '/product/lazada/singledelete',
        method: 'delete',
        params:params
    })
}

// 修改Lazada备注
export function updateLazadaRemark(form) {
    return request({
        url: '/product/lazada/updateLazadaRemark',
        method: 'put',
        data: form
    })
}

//更新产品来源url
export function updateLazadaDataUrl(param) {
    return request({
        url: '/product/lazada/updateLazadaDataUrl',
        method: 'put',
        params:param
    })
}
/**
 * 批量删除
 */
export function batchdelete(pIds) {
    return request({
        url: '/product/lazada/batchdelete/'+pIds,
        method: 'delete'
    })
}


/**
 * 将Lazada产品批量移动分类
 * @param data
 */
export function batchMoveCatalog(data){
    return request({
        url: '/product/lazada/batchMoveCatalog',
        method: 'put',
        data: data
    })
}

//批量下架
export function batchUpdateToShelves(data){
    return request({
        url: '/product/lazada/batchUpdateToShelves',
        method: 'put',
        data: data
    })
}



// 查询产品的编辑数据
export function getLazadaEdit(pId) {
    var params={
        pId:pId
    }
    return request({
        url: '/product/lazada/getLazadaEdit',
        method: 'get',
        params:params
    })
}

//上传图片
export function uploadImg(data) {
    return request({
        url:'/product/lazada/uploadImg',
        method:'post',
        data:data
    })
}

//保存并移入待发布
export function saveAndMoveToready(data) {
    return request({
        url:'/product/lazada/saveAndMoveToready',
        method:'post',
        data:data
    })
}

//由创建到发布
export function publishItem(data) {
    return request({
        url:'/product/lazada/publishItem',
        method:'put',
        data:data
    })
}

//由待发布到发布
export function publishToOnline(data) {
    return request({
        url:'/product/lazada/publishToOnline',
        method:'put',
        data:data
    })
}

//批量发布
export function batchPublishItem(data){
    return request({
        url: '/product/lazada/batchPublishItem',
        method: 'put',
        data: data
    })
}

//批量定时发布
export function batchIntervalPublishItem(data){
    return request({
        url: '/product/lazada/release',
        method: 'post',
        params: data
    })
}

//批量取消定时发布
export function batchCancelInterval(data){
    return request({
        url: '/product/lazada/cancelRelease',
        method: 'post',
        params: data
    })
}


//根据状态查询数量
export function verSearch(){
    return request({
        url: '/product/lazada/verSearch',
        method: 'get'
    })
}





















